import { OrderRouteItem, schOrderRouteItem } from '@aloft/toolkit-shared';

import { useLocation } from 'react-router';

export const useCurrentNavItem = (): OrderRouteItem | undefined => {
  const { pathname } = useLocation();
  return schOrderRouteItem.options.find((item) => pathname.includes(item));
};
